/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   Checks whether we should remove the tour time and type picker from the tour form
 */

import { selectIsMobile } from '@zcode-ui/web-zumper-global-state'
import { TOUR } from '@zcode/nr/es/shared/constants/message'
import type { Listable, MaybeEmptyProperty } from '@zcode/state-type'
import { useSelector } from 'react-redux'
import { useMessageFormContext } from '../MessageForm/NewMessageForm/MessageFormContext'
import { useTourTypeOptions } from '../MessageForm/TourOptions/helpers/useTourTypeOptions'
import { useHasInstantTourBooking } from '../MessageForm/TourOptions/useHasInstantTourBooking'
import type { Values } from '../MessageForm/helpers/getValidationSchema'

export type Entity = Listable | MaybeEmptyProperty

export const useHideTimeAndTypePicker = (entity: Entity | null | undefined) => {
  const { intent } = useMessageFormContext<Values>()
  const skipFetchingTourIntegration = intent !== TOUR
  const { hasInstantTourAvailability } = useHasInstantTourBooking(
    entity,
    skipFetchingTourIntegration
  )
  const { tourTypeOptions } = useTourTypeOptions(entity, skipFetchingTourIntegration)
  const ignoreTourTime = !hasInstantTourAvailability && intent === TOUR
  const isMobile = useSelector(selectIsMobile)
  const isSingleTourType = tourTypeOptions.length < 2
  const hideTourDatePicker = ignoreTourTime && isSingleTourType && isMobile
  const hideTourTypePicker = ignoreTourTime && isSingleTourType
  return {
    skipTourFormStep1: hideTourDatePicker && hideTourTypePicker,
  }
}
